import React from "react";
import Loader from "../Loder/loader";
import { DocumentDownloadIcon, UploadCsvIcon } from "../../assets/icon";
import {
  CAMPAIGN_TYPES,
  formatCampaignDate,
  formatCampaignTime,
  formatMonthDayYearDate,
  formatOutreachWindowTime,
  formatSlashDate,
  getCampaignStatus,
  getCampaignTypeLabel,
  isComplianceCampaign,
  isWeekendDate,
  isWelcomeOnboardingCampaign,
} from "./aiCampaignsUtils";

const ManageCampaignDetailsTab = ({
  campaignData,
  detailsLoading,
  getReadableCsvFileName,
  onDownloadCsv,
}) => {
  const isEnrollment =
    campaignData?.campaignType === CAMPAIGN_TYPES.ENROLLMENT;
  const isWelcomeOnboarding = isWelcomeOnboardingCampaign(
    campaignData?.campaignType,
  );
  // Weekends are always auto-blackout (and hidden from the chip list) for both Welcome
  // Onboarding and Compliance — only Enrollment shows every stored blackout date as-is.
  const isWeekendAutoBlackoutType =
    isWelcomeOnboarding || isComplianceCampaign(campaignData?.campaignType);
  // console.log("blackoutDates response", campaignData?.blackoutDates);
  const blackoutDates = (campaignData?.blackoutDates || []).filter(
    (date) => !isWeekendAutoBlackoutType || !isWeekendDate(date),
  );

  return (
    <>
      {detailsLoading && (
        <Loader loaderTransform="loaderTransform" />
      )}
      <div className="usercard mb-30">
        <div className="campaignDetailsCard d-flex justify-content-between align-items-center mb-10">
          <span className="campaigncardHeader ">Campaign Information</span>
          {getCampaignStatus(campaignData?.status || "Active") ?? (
            <span className="manage-campaign-status">
              {campaignData?.status || "Active"}
            </span>
          )}
        </div>
        <hr className="m-0  manage-campaign-divider" />
        <div className="campaigncardBody grid-1 w-100">
          <div className="d-grid grid-3 mb-2 gap-20">
            <div className=" ">
              <div className="small mb-2 manage-campaign-field-label fs-14">
                Campaign Name
              </div>
              <div className="fw-bold manage-campaign-field-value fs-16 ">
                {campaignData?.campaignName || "-"}
              </div>
            </div>
            <div className=" ">
              <div className="small mb-2 manage-campaign-field-label fs-14">
                Campaign Type
              </div>
              <div className="fw-bold manage-campaign-field-value fs-16">
                {getCampaignTypeLabel(campaignData?.campaignType)}
              </div>
            </div>
            {!isWelcomeOnboarding && (
              <div className=" ">
                <div className="small mb-2 manage-campaign-field-label fs-14">
                  Client Name
                </div>
                <div className="fw-bold manage-campaign-field-value fs-16">
                  {campaignData?.clientName || "-"}
                </div>
              </div>
            )}
            {!isWelcomeOnboarding && (
              <div className="">
                <div className="small mb-2 manage-campaign-field-label fs-14">
                  Group Code
                </div>
                <div className="fw-bold manage-campaign-field-value fs-16">
                  {campaignData?.groupCode || "N/A"}
                </div>
              </div>
            )}
            {!isWelcomeOnboarding && (
              <div className="">
                <div className="small mb-2 manage-campaign-field-label fs-14">
                  Product
                </div>
                <div className="fw-bold manage-campaign-field-value fs-16">
                  {campaignData?.productName || "N/A"}
                </div>
              </div>
            )}
            {!isWelcomeOnboarding && (
              <div className="">
                <div className="small mb-2 manage-campaign-field-label fs-14">
                  Coverage Start Date
                </div>
                <div className="fw-bold manage-campaign-field-value fs-16">
                  {formatSlashDate(campaignData?.coverageStartDate)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="usercard mb-30">
        <div className="campaignDetailsCard d-flex flex-column ">
          <span className="campaigncardHeader mb-2 ">Campaign Duration</span>
          <p className="mb-0 small manage-campaign-subtext fs-16">
            {isWelcomeOnboarding
              ? "Welcome campaign remains active from the start date with no end date"
              : "AI Agent will contact perspective members with in the date range"}
          </p>
        </div>
        <hr className="m-0 " />
        <div className="campaigncardBody grid-1 w-100">
          <div className="d-flex flex-column">
            <div className="manage-campaign-duration-grid">
              <div className="manage-campaign-duration-item">
                <div className="small mb-2 manage-campaign-field-label fs-14">
                  Campaign Start Date
                </div>
                <div className="fw-bold manage-campaign-field-value fs-16">
                  {formatCampaignDate(campaignData?.campaignStartDate)}
                </div>
              </div>
              <div className="manage-campaign-duration-item">
                <div className="small mb-2 manage-campaign-field-label fs-14">
                  Campaign Start Time
                </div>
                <div className="fw-bold manage-campaign-field-value fs-16">
                  {formatCampaignTime(
                    campaignData?.campaignStartTime,
                    campaignData?.startTimezone || campaignData?.campaignTimeZone,
                  )}
                </div>
              </div>
              {!isWelcomeOnboarding && (
                <>
                  <div className="manage-campaign-duration-item">
                    <div className="small mb-2 manage-campaign-field-label fs-14">
                      Campaign End Date
                    </div>
                    <div className="fw-bold manage-campaign-field-value fs-16">
                      {formatCampaignDate(campaignData?.campaignEndDate)}
                    </div>
                  </div>
                  <div className="manage-campaign-duration-item">
                    <div className="small mb-2 manage-campaign-field-label fs-14">
                      Campaign End Time
                    </div>
                    <div className="fw-bold manage-campaign-field-value fs-16">
                      {formatCampaignTime(
                        campaignData?.campaignEndTime,
                        campaignData?.endTimezone || campaignData?.campaignTimeZone,
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
            {(blackoutDates.length > 0 || isWeekendAutoBlackoutType) && (
              <>
                <hr className="m-0  my-4" />
                <div className="mt-2">
                  <div className="small mb-3 manage-campaign-field-label fs-14">
                    Blackout Dates (Optional)
                  </div>
                  {isWeekendAutoBlackoutType && (
                    <p className="mb-3 text-muted small">
                      Weekend dates will be automatically considered as blackout dates.
                    </p>
                  )}
                  {blackoutDates.length > 0 && (
                    <div className="d-flex flex-wrap gap-2">
                      {blackoutDates.map((date, idx) => (
                        <span
                          key={idx}
                          className="dateCard manage-campaign-date-card fs-16"
                        >
                          {formatMonthDayYearDate(date)}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="usercard mb-30 ">
        <div className="campaignDetailsCard d-flex flex-column">
          <span className="campaigncardHeader mb-2 ">
            Preferred Time to Outreach
          </span>
          <p className="mb-0 small manage-campaign-subtext">
            AI Agent will contact perspective members in the preferred time
            windows
          </p>
        </div>
        <hr className="m-0" />
        <div className="campaigncardBody d-flex flex-column timeWindow ">
          <div className="small manage-campaign-field-label fs-14">
            Time Window
          </div>
          <div className="fw-bold manage-campaign-field-value manageCampaignTimeWindoList fs-16">
            {(() => {
              const timeWindows = (campaignData?.outreachWindows || [])
                .filter((tw) => tw?.isActive === true)
                .map(
                  (tw) =>
                    `${formatOutreachWindowTime(tw.startTime)} - ${formatOutreachWindowTime(tw.endTime)} ${tw.timezone || ""}`.trim(),
                )
                .filter(Boolean);

              if (!timeWindows?.length) {
                return "-";
              }

              return timeWindows.map((label, idx) => (
                <React.Fragment key={`${label}-${idx}`}>
                  {idx > 0 && (
                    <span className="manage-campaign-time-separator" aria-hidden>
                      •
                    </span>
                  )}
                  <span className="manage-campaign-time-item">{label}</span>
                </React.Fragment>
              ));
            })()}
          </div>
        </div>
      </div>

      <div className="usercard mb-30">
        <div className="campaignDetailsCard d-flex flex-column">
          <span className="campaigncardHeader ">CSV Upload - Census</span>
        </div>
        <hr className="m-0" />
        <div
          className={`csvUploadedListContainer ${
            !(isEnrollment && campaignData?.csvFileName) ? "grid-1" : ""
          }`}
        >
          {isEnrollment && campaignData?.csvFileName ? (
            <div className="d-flex align-items-center justify-content-between p-3 border rounded manage-campaign-upload-box gap-4">
              <div className="d-flex align-items-center gap-3 ">
                <div className="uploadCsvIconContainer">
                  <UploadCsvIcon />
                </div>
                <div
                  className="fw-bold fs-14  "
                  style={{
                    color: "#162C4E",
                    maxWidth: "300px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {getReadableCsvFileName(campaignData?.csvFileName)}
                </div>
              </div>
              <div
                className="cursor-pointer d-flex manage-campaign-download"
                role="button"
                tabIndex={0}
                onClick={onDownloadCsv}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onDownloadCsv();
                  }
                }}
              >
                <DocumentDownloadIcon />
              </div>
            </div>
          ) : (
            <div className="NAScreen">N/A</div>
          )}
        </div>
      </div>
    </>
  );
};

export default ManageCampaignDetailsTab;
